import { removeNotNumberFromString } from '@app/libs/inputFormat/index';

/**
 * 문자열에서 숫자(0-9)문자 왜 다른 문자를 제외하고,
 * 사업자 번호 형식에 맞게 대쉬(-)를 추가한 문자를 반환합니다.
 */
function getBizNumberFormat(value: string) {
  return removeNotNumberFromString(value).replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
}

export default getBizNumberFormat;
